<template>
  <header>
    <v-navigation-drawer app v-model="drawer" clipped>
      <Navigation />
    </v-navigation-drawer>
    <v-app-bar class="gradient" app clipped-left>
      <v-app-bar-nav-icon @click="drawer = !drawer" class="d-flex d-sm-none"></v-app-bar-nav-icon>
      <Tab />
    </v-app-bar>
  </header>
</template>

<script>
import Navigation from "./Navigation.vue";
import Tab from "@/components/Header/Tab";

export default {
  name: "AppHeader",
  components: {
    Navigation,
    Tab
  },
  data() {
    return {
      drawer: false,
    };
  },
};
</script>

<style>
.gradient {
  /* background: linear-gradient(to right, #f5f5f5,70%,#00ced1,#a9a9a9); */
  background: linear-gradient(to right, #f5f5f5,70%,#a9a9a9);
}

</style>